import y from "../../../../public/projects/unique/projects/y.jpg";
import s from "../../../../public/projects/unique/logo/s.png";
import evergreen from "../../../../public/projects/unique/projects/ev.jpg"

// kville
import overviewImagekville from "../../../../public/projects/unique/kville/overview/1.webp";
import bannerDesktopImagekville from "../../../../public/projects/unique/kville/banner/1.webp";
import bannerMobileImagekville from "../../../../public/projects/unique/kville/banner/2.webp";
import Locationkville from "../../../../public/projects/unique/kville/location/1.webp";
import Hightlightskville from "../../../../public/projects/unique/kville/highlights/1.webp";
import floorplan1kville from "../../../../public/projects/unique/kville/floorplan/1.webp";
import floorplan2kville from "../../../../public/projects/unique/kville/floorplan/2.webp";
import floorplan3kville from "../../../../public/projects/unique/kville/floorplan/3.webp";
import floorplan4kville from "../../../../public/projects/unique/kville/floorplan/4.webp";
import floorplan5kville from "../../../../public/projects/unique/kville/floorplan/5.webp";
import locationiconkville from "../../../../public/projects/unique/kville/overview/l.png";
import caliconkville from "../../../../public/projects/unique/kville/overview/c.png";
import newlaunchiconkville from "../../../../public/projects/unique/kville/overview/n.png";
import gallery1kville from "../../../../public/projects/unique/kville/gallery/1.webp";
import gallery2kville from "../../../../public/projects/unique/kville/gallery/2.webp";
import gallery3kville from "../../../../public/projects/unique/kville/gallery/3.webp";
import gallery4kville from "../../../../public/projects/unique/kville/gallery/4.webp";
import gallery5kville from "../../../../public/projects/unique/kville/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/unique/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/unique/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/unique/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/unique/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/unique/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/unique/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/unique/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/unique/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/unique/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/unique/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/unique/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/unique/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/unique/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/unique/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/unique/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/unique/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/unique/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/unique/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/unique/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/unique/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/unique/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/unique/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/unique/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/unique/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/unique/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/unique/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/unique/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/unique/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/unique/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/unique/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/unique/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/unique/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/unique/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/unique/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/unique/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/unique/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/unique/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/unique/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/unique/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/unique/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/unique/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/unique/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/unique/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/unique/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/unique/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/unique/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/unique/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/unique/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/unique/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/unique/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/unique/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/unique/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/unique/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/unique/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/unique/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/unique/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/unique/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/unique/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/unique/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/unique/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/unique/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/unique/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/unique/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/unique/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/unique/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/unique/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/unique/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/unique/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/unique/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/unique/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/unique/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/unique/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/unique/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/unique/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/unique/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/unique/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/unique/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/unique/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/unique/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/unique/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/unique/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/unique/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/unique/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/unique/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/unique/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/unique/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/unique/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/unique/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/unique/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/unique/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/unique/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/unique/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/unique/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/unique/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/unique/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/unique/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/unique/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/unique/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/unique/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/unique/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/unique/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/unique/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/unique/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/unique/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/unique/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/unique/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/unique/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/unique/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/unique/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/unique/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/unique/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/unique/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/unique/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/unique/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/unique/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/unique/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/unique/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/unique/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/unique/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/unique/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/unique/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/unique/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/unique/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/unique/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/unique/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/unique/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/unique/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/unique/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/unique/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/unique/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/unique/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/unique/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/unique/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/unique/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/unique/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/unique/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/unique/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/unique/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/unique/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/unique/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/unique/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/unique/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/unique/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/unique/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/unique/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/unique/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/unique/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/unique/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/unique/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/unique/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/unique/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/unique/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/unique/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/unique/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/unique/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/unique/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/unique/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/unique/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/unique/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/unique/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/unique/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/unique/projectten/gallery/5.webp";



export const developerunique = {
  properties: [
    {
      name: "unique The Trillion",
      image: bannerMobileImagekville,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "unique",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/unique-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "unique The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `unique, a 100% FDI funded real-estate developer, backed by unique Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsunique = {

  kville: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagekville,
      bannerMobileImage: bannerMobileImagekville,
      textOverlay: "",
      data: {
        title: "Unique K Ville",
        subtitle: "Kiwale, Pune",
        starting_price: "₹ 70 Lakh Onwards",
        payment_plan: "Flexible Payment Plans",
        rerano: "P52100020646",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Unique K Ville",
      description: [
        "Unique K Ville in Kiwale, Pune, is a premium residential project by Unique Chintamani Development LLP, offering a blend of modern living and strategic location. Spread across 7.5 acres, the development comprises 7 towers with configurations of B+G+14 floors, housing 2, 2.5, and 3 BHK apartments. The project is RERA registered under IDs P52100020646, P52100026606, and P52100031164, ensuring transparency and compliance.",
        "This project is located near Bhakti Shakti Chowk, Unique K Ville offers excellent connectivity to the Pune-Pune Expressway, Hinjewadi IT Park, and other key areas. The project is just 1.5 km from the Pune-Bangalore Highway and 3 km from the Hanging Bridge, making daily commuting convenient.",
        "Residents can enjoy a plethora of amenities, including a clubhouse, swimming pool, gymnasium, landscaped gardens, children's play area, and a multipurpose play court. The project also features 24x7 water supply, power backup, and advanced security systems, ensuring a comfortable and secure living experience.",
      ],
      keywordLinks: {
       
      },
      image: overviewImagekville,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconkville,
          title: "₹ 70 Lakh Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconkville,
          title: "Flexible Plans",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconkville,
          title: "Status",
          subtitle: "Under Construction",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "740 - 838 sq.ft.",
          price: "₹ 70.3 - 79.61 L",
          eoiAmount: "Onwards",
        },
        {
          type: "3 BHK",
          area: "863 - 1032 sq.ft.",
          price: "₹ 71.8 - 98.78 L",
          eoiAmount: "Onwards",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "740 - 838 sq.ft.",
        price: "₹ 70.3 - 79.61 L",
        image: floorplan1kville,
      },
      {
        type: "3 BHK",
        area: "863 - 1032 sq.ft.",
        price: "₹ 71.8 - 98.78 L",
        image: floorplan2kville,
      }
    ],

    highlights: {
      images: Hightlightskville,
      tagline: "Highlights",
      features: [
        "Located at just 5 minutes drive from Akurdi Railway Station",
        "Well connected to Pune city with great access to Pune-Pune Expressway via Mukai Chowk",
        "35+ lifestyle amenities",
        "It is an ideal mix of lifestyle, connectivity, luxury and openness",
        "MCA stadium, school, colleges, and workplace so close by",
      ],
    },

    location: {
      image: Locationkville,
      data: [
        {
          airport: {
            distance_time: "29.4 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "4.1 km",
            name: "D. Y. Patil International University"
          },
          railwayormetro: {
            distance_time: "7.1 km",
            name: "Chinchwad Junction"
          },
          hospital: {
            distance_time: "2.0 km",
            name: "Shubhshree Multispeciality Hospital"
          },
          mall: {
            distance_time: "3.6 km",
            name: "Nirman Greens One Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1kville },
        { image: gallery2kville },
        { image: gallery3kville },
        { image: gallery4kville },
        { image: gallery5kville },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nI'm interested in Unique K Ville, Pune. Can you share more details?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Unique K Ville, Pune. Kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of Unique K Ville?",
        answer: "The project is developed by Unique Chintamani Development LLP.",
      },
      {
        question: "What are the available apartment configurations?",
        answer: "Unique K Ville offers 2 BHK and 3 BHK apartments.",
      },
      {
        question: "What is the size range of the apartments?",
        answer: "The apartments range from approximately 740 sq.ft. to 1,032 sq.ft. in carpet area, providing spacious living options.",
      },
      {
        question: "What is the possession timeline for the project?",
        answer: "The possession for Unique K Ville is expected by December 2026.",
      },
      {
        question: "Is the project RERA registered?",
        answer: "Yes, Unique K Ville is RERA registered with IDs P52100020646, P52100026606, P52100031164.",
      },
      {
        question: "What amenities are provided in the project?",
        answer: "Residents can enjoy amenities like a clubhouse, swimming pool, gymnasium, landscaped gardens, children's play area, and a multipurpose play court. The project also features 24x7 water supply, power backup, and advanced security systems.",
      },
      {
        question: "What is the price range of the apartments?",
        answer: "The price of apartments in Unique K Ville ranges from ₹70 lakhs to 98 lakhs.",
      },
      {
        question: "How many towers and floors are there in the project?",
        answer: "The project comprises 7 towers with configurations of B+G+14 floors, offering a total of 932 units.",
      },
      {
        question: "What are the nearby landmarks and facilities?",
        answer: "Unique K Ville is close to educational institutions like D.Y. Patil College, healthcare facilities such as Shubhshree Multispeciality Hospital, and shopping destinations like Nirman Greens One Mall. It's also well-connected to major transportation routes.",
      },
      {
        question: "Is there parking available for residents?",
        answer: "Yes, Unique K Ville provides ample parking space for residents.",
      }
    ],

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry - Unique K Ville, Pune",
      to_email: "leads@puneproperty.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecttwo,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "unique The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "unique The Trillion",
      description: [
        "unique The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by unique Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at unique Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at unique Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of unique The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "unique": "/developers/unique",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in unique The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is unique The Trillion located?",
        answer: `unique The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at unique The Trillion?",
        answer: `unique The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in unique The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at unique The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, unique The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of unique The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at unique The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of unique The Trillion?",
        answer: `unique The Trillion is developed by unique Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is unique The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, unique The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from unique The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
